<template>
  <div
    v-if="layout.type === 'media-middle'"
    class="RMPE-DynamicField-Media"
  >
    <img
      v-if="layout.image !== null"
      :src="layout.image"
      alt=""
    >
    <VideoEmbed
      v-else-if="layout.video !== null"
      :url="layout.video"
    />
  </div>
</template>

<script>
import VideoEmbed from '@rmpenterprise/microsite-youtube-embed';

export default {
  components: { VideoEmbed },

  props: {
    layout: {
      type: Object,
      default: null,
    },
  },
};
</script>
<style scoped lang="scss">
.RMPE-DynamicField-Media{
  margin-bottom: 1.5rem;
}
</style>
